import {
  APPROVE_SUCCESS,
  ACTIVATION_SUCCESS,
  STATUS_CHANGE_SUCCESS
} from './dwellings';

const LIST = 'organizations/LIST';
const LIST_SUCCESS = 'organizations/LIST_SUCCESS';
const LIST_FAIL = 'organizations/LIST_FAIL';
const SINGLE = 'organizations/SINGLE';
const SINGLE_SUCCESS = 'organizations/SINGLE_SUCCESS';
const SINGLE_FAIL = 'organizations/SINGLE_FAIL';
const UPDATE = 'organizations/UPDATE';
const UPDATE_SUCCESS = 'organizations/UPDATE_SUCCESS';
export const UPDATE_FAIL = 'organizations/UPDATE_FAIL';
const CANCEL = 'organizations/CANCEL';
const CANCEL_SUCCESS = 'organizations/CANCEL_SUCCESS';
const CANCEL_FAIL = 'organizations/CANCEL_FAIL';
const USERS = 'organizations/USERS';
const USERS_SUCCESS = 'organizations/USERS_SUCCESS';
const USERS_CANCEL = 'organizations/USERS_CANCEL';
const UPDATE_USER_ROLE = 'organizations/UPDATE_USER_ROLE';
const UPDATE_USER_ROLE_SUCCESS = 'organizations/UPDATE_USER_ROLE_SUCCESS';
export const UPDATE_USER_ROLE_FAIL = 'organizations/UPDATE_USER_ROLE_FAIL';
const CREATE = 'organizations/CREATE';
export const CREATE_SUCCESS = 'organizations/CREATE_SUCCESS';
export const CREATE_FAIL = 'organizations/CREATE_FAIL';
const CREATE_USER = 'organizations/CREATE_USER';
const CREATE_USER_SUCCESS = 'organizations/CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'organizations/CREATE_USER_FAIL';
const CREATE_DWELLING = 'organizations/CREATE_DWELLING';
const CREATE_DWELLING_SUCCESS = 'organizations/CREATE_DWELLING_SUCCESS';
export const CREATE_DWELLING_FAIL = 'organizations/CREATE_DWELLING_FAIL';
const UPDATE_DWELLING = 'organizations/UPDATE_DWELLING';
const UPDATE_DWELLING_SUCCESS = 'organizations/UPDATE_DWELLING_SUCCESS';
export const UPDATE_DWELLING_FAIL = 'organizations/UPDATE_DWELLING_FAIL';
const DWELLINGS = 'organizations/DWELLINGS';
const DWELLINGS_SUCCESS = 'organizations/DWELLINGS_SUCCESS';
const DWELLINGS_FAIL = 'organizations/DWELLINGS_FAIL';
const UPLOAD = 'organizations/UPLOAD';
const UPLOAD_SUCCESS = 'organizations/UPLOAD_SUCCESS';
const UPLOAD_FAIL = 'organizations/UPLOAD_FAIL';
const SINGLE_DWELLING = 'organizations/SINGLE_DWELLING';
const SINGLE_DWELLING_SUCCESS = 'organizations/SINGLE_DWELLING_SUCCESS';
const SINGLE_DWELLING_FAIL = 'organizations/SINGLE_DWELLING_FAIL';
const ACTIVATE = 'organizations/ACTIVATE';
const ACTIVATE_SUCCESS = 'organizations/ACTIVATE_SUCCESS';
export const ACTIVATE_FAIL = 'organizations/ACTIVATE_FAIL';
const CLEAR = 'organizations/clear-dwelling';

const initialState = {
  list: [],
  single: null,
  users: [],
  dwellings: {
    list: [],
    single: null
  }
};

const API_ENDPOINT = '/api/organizations';
const DWELLING_ENDPOINT = '/api/dwellings';

export default function org(state = initialState, action) {
  switch (action.type) {
    case LIST_SUCCESS:
      return {
        ...state,
        list: action.payload.results
      };

    case USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.results
      };

    case USERS:
      return {
        ...state,
        users: []
      };

    case ACTIVATE_SUCCESS: {
      const list = state.list.filter(
        (org) => org.uuid !== action.payload.result.uuid
      );
      list.push(action.payload.result);

      return {
        ...state,
        list
      };
    }

    case CLEAR:
      return {
        ...state,
        dwellings: {
          ...state.dwellings,
          single: null
        }
      };

    case DWELLINGS_SUCCESS:
      return {
        ...state,
        dwellings: {
          ...state.dwellings,
          list: action.payload.results
        }
      };

    case SINGLE_DWELLING:
      return {
        ...state,
        dwellings: {
          ...state.dwellings,
          single: null
        }
      };

    case SINGLE_DWELLING_SUCCESS:
    case UPDATE_DWELLING_SUCCESS:
    case CREATE_DWELLING_SUCCESS:
      return {
        ...state,
        dwellings: {
          ...state.dwellings,
          single: action.payload.result
        }
      };

    case ACTIVATION_SUCCESS:
    case APPROVE_SUCCESS:
    case STATUS_CHANGE_SUCCESS:
      return {
        ...state,
        dwellings: {
          ...state.dwellings,
          single: action.payload
        }
      };

    case DWELLINGS:
      return {
        ...state,
        dwellings: []
      };

    case SINGLE:
      return {
        ...state,
        dwellings: {
          ...state.dwelling,
          single: null
        }
      };

    case CREATE_SUCCESS: {
      const list = state.list.filter(
        (org) => org.uuid !== action.payload.result.uuid
      );
      list.push(action.payload.result);
      return {
        ...state,
        list
      };
    }

    case UPDATE_USER_ROLE_SUCCESS: {
      const users = state.users.filter(
        (user) => user.uuid !== action.payload.result.uuid
      );
      users.push(action.payload.result);
      return {
        ...state,
        users
      };
    }

    case CANCEL_SUCCESS:
    case UPDATE_SUCCESS:
    case SINGLE_SUCCESS:
      return {
        ...state,
        single: action.payload.result
      };

    default:
      return state;
  }
}

export function create(data) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: (client) => client.post(`${API_ENDPOINT}`, { data })
  };
}

export function activate(uuid) {
  return {
    types: [ACTIVATE, ACTIVATE_SUCCESS, ACTIVATE_FAIL],
    promise: (client) => client.get(`${API_ENDPOINT}/${uuid}/activate`)
  };
}

export function single(id) {
  return {
    types: [SINGLE, SINGLE_SUCCESS, SINGLE_FAIL],
    promise: (client) => client.get(`${API_ENDPOINT}/${id}`)
  };
}

export function list() {
  return {
    types: [LIST, LIST_SUCCESS, LIST_FAIL],
    promise: (client) => client.get(`${API_ENDPOINT}`)
  };
}

export function update({ uuid, data }) {
  return {
    types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
    promise: (client) => client.post(`${API_ENDPOINT}/${uuid}`, { data })
  };
}

export function cancel(uuid) {
  return {
    types: [CANCEL, CANCEL_SUCCESS, CANCEL_FAIL],
    promise: (client) => client.delete(`${API_ENDPOINT}/${uuid}`)
  };
}

export function users(uuid) {
  return {
    types: [USERS, USERS_SUCCESS, USERS_CANCEL],
    promise: (client) => client.get(`${API_ENDPOINT}/${uuid}/users`)
  };
}

export function updateUserRole(uuid, data) {
  return {
    types: [UPDATE_USER_ROLE, UPDATE_USER_ROLE_SUCCESS, UPDATE_USER_ROLE_FAIL],
    promise: (client) => client.post(`${API_ENDPOINT}/roles/${uuid}`, { data })
  };
}

export function createUser(uuid, data) {
  return {
    types: [CREATE_USER, CREATE_USER_SUCCESS, CREATE_USER_FAIL],
    promise: (client) => client.post(`${API_ENDPOINT}/${uuid}/users`, { data })
  };
}

export function upload(data) {
  return {
    types: [UPLOAD, UPLOAD_SUCCESS, UPLOAD_FAIL],
    promise: (client) =>
      client.post(`${DWELLING_ENDPOINT}/upload`, { data, type: null })
  };
}

export function createDwelling(uuid, data) {
  const endpoint = uuid
    ? `${DWELLING_ENDPOINT}/organizations/${uuid}`
    : DWELLING_ENDPOINT;
  return {
    types: [CREATE_DWELLING, CREATE_DWELLING_SUCCESS, CREATE_DWELLING_FAIL],
    promise: (client) => client.post(endpoint, { data })
  };
}

export function updateDwelling(uuid, data) {
  return {
    types: [UPDATE_DWELLING, UPDATE_DWELLING_SUCCESS, UPDATE_DWELLING_FAIL],
    promise: (client) => client.post(`${DWELLING_ENDPOINT}/${uuid}`, { data })
  };
}

export function singleDwelling(uuid) {
  return {
    types: [SINGLE_DWELLING, SINGLE_DWELLING_SUCCESS, SINGLE_DWELLING_FAIL],
    promise: (client) => client.get(`${DWELLING_ENDPOINT}/${uuid}`)
  };
}

export function dwellings(uuid) {
  return {
    types: [DWELLINGS, DWELLINGS_SUCCESS, DWELLINGS_FAIL],
    promise: (client) =>
      client.get(`${DWELLING_ENDPOINT}/organizations/${uuid}`)
  };
}

export function clear() {
  return {
    type: CLEAR
  };
}
